import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
import events from './events'
import MultiTab from './MultiTab'
import './index.less'

const api = {
  /**
   * open new tab on route fullPath
   * @param config
   */
  open: function (config) {
    $emit(events, 'open', config)
  },
  rename: function (key, name) {
    $emit(events, 'rename', { key: key, name: name })
  },
  /**
   * close current page
   */
  closeCurrentPage: function () {
    this.close()
  },
  /**
   * close route fullPath tab
   * @param config
   */
  close: function (config) {
    $emit(events, 'close', config)
  },
}

MultiTab.install = function (Vue) {
  if (window.$vueApp.config.globalProperties.$multiTab) {
    return
  }
  api.instance = events
  window.$vueApp.config.globalProperties.$multiTab = api
  window.$vueApp.component('multi-tab', MultiTab)
}

export default MultiTab
